




























































































































































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Button, FormItem, Input, Option, Select } from 'element-ui';
import NullableNumberInput from '@/components/element-ui/NullableNumberInput.vue';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';

// sections
import ContactSection from '@/components/documents/sections/ContactInformation.vue';

// Options
import { containerSizeOptions } from '@/constants/containerSizeOptions';
import packagingOptions from '@/constants/packagingOptions';
import places from '@/mixins/placeOptions';
import vessels from '@/mixins/vesselOptions.ts';

// types
import {
  ShipmentDocumentDataInput,
  ShipmentDocumentFields,
  TransportationCargoTypeEnum,
  TransportationTypeEnum
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    ContactSection,
    NullableNumberInput,
    UtcDatePicker,
    'el-button': Button,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class SeaWaybill extends Mixins(places, vessels) {
  @Prop() document!: ShipmentDocumentFields;
  @Prop({ default: false, type: Boolean }) isLoading!: boolean;

  formInput: ShipmentDocumentDataInput = {};

  readonly emptyContainer = {
    containerNumber: null,
    sealNumber: null,
    containerType: null
  };

  // select options
  readonly containerSizeOptions = containerSizeOptions();
  readonly packagingOptions = packagingOptions();

  readonly TransportationCargoTypeEnum = TransportationCargoTypeEnum;

  created() {
    this.setFormInput();
    // disable auto select for place select
    this.autoSelect = false;
    // init transport type for place select
    this.transportationType = TransportationTypeEnum.sea;
  }

  addContainer() {
    this.formInput.containerNumbers.push({ ...this.emptyContainer });
  }

  deleteContainer(index) {
    this.formInput.containerNumbers.splice(index, 1);
  }

  @Watch('formInput.containerNumbers.length')
  setQuantityOfContainers(number: number) {
    this.formInput.quantityOfContainers = number || 0;
  }

  @Watch('document')
  setFormInput() {
    this.formInput = {
      // IMPORTANT re send readonly data
      shipmentCustomerRole: this.document.data?.shipmentCustomerRole,
      shipmentReference: this.document.data?.shipmentReference,
      transportCargoType: this.document.data?.transportCargoType,
      transportationType: this.document.data?.transportationType,
      // END IMPORTANT
      houseBlNumber: this.document.data?.houseBlNumber,
      // Contact information
      shipmentShipperName: this.document.data?.shipmentShipperName,
      shipmentShipperAddress: this.document.data?.shipmentShipperAddress,
      shipmentShipperEmail: this.document.data?.shipmentShipperEmail,
      shipmentShipperPhone: this.document.data?.shipmentShipperPhone,
      shipmentConsigneeName: this.document.data?.shipmentConsigneeName,
      shipmentConsigneeAddress: this.document.data?.shipmentConsigneeAddress,
      shipmentConsigneeEmail: this.document.data?.shipmentConsigneeEmail,
      shipmentConsigneePhone: this.document.data?.shipmentConsigneePhone,
      shipmentNotifyName: this.document.data?.shipmentNotifyName,
      shipmentNotifyAddress: this.document.data?.shipmentNotifyAddress,
      shipmentNotifyEmail: this.document.data?.shipmentNotifyEmail,
      shipmentNotifyPhone: this.document.data?.shipmentNotifyPhone,
      // Sea Waybill
      preCarriageBy: this.document.data?.preCarriageBy,
      placeOfReceipt: this.document.data?.placeOfReceipt,
      placeOfDelivery: this.document.data?.placeOfDelivery,
      vesselName: this.document.data?.vesselName,
      voyageNumber: this.document.data?.voyageNumber,
      portOfDischarge: this.document.data?.portOfDischarge,
      portOfLoading: this.document.data?.portOfLoading,
      shipmentDeliveryAgentAddress: this.document.data
        ?.shipmentDeliveryAgentAddress,
      shipmentDeliveryAgentEmail: this.document.data
        ?.shipmentDeliveryAgentEmail,
      shipmentDeliveryAgentName: this.document.data?.shipmentDeliveryAgentName,
      shipmentDeliveryAgentPhone: this.document.data
        ?.shipmentDeliveryAgentPhone,
      finalDestination: this.document.data?.finalDestination,
      containerNumbers: this.document.data?.containerNumbers.length
        ? [...this.document.data?.containerNumbers]
        : [{ ...this.emptyContainer }],
      packagingQuantity: this.document.data?.packagingQuantity,
      packaging: this.document.data?.packaging,
      grossVolume: this.document.data?.grossVolume,
      grossWeight: this.document.data?.grossWeight,

      shippingMarks: this.document.data?.shippingMarks,
      quantityOfContainers:
        this.document.data?.quantityOfContainers ||
        this.formInput.containerNumbers?.length || 0,
      descriptionOfGoods: this.document.data?.descriptionOfGoods,
      shipmentPaymentPlace: this.document.data?.shipmentPaymentPlace,
      blType: this.document.data?.blType,
      blPlaceOfIssuance: this.document.data?.blPlaceOfIssuance,
      blNumberOfOriginals: this.document.data?.blNumberOfOriginals,
      estimatedDateOfDeparture: this.document.data?.estimatedDateOfDeparture
    };
  }
}
